import type { ProductDetails } from "@raumagarn/formatters";
import { clsx } from "@trydig/ui";
import { DownloadIcon } from "~/components/icons/16/DownloadIcon";
import pdpStyles from "~/features/products/ProductDetails/PdpActions/PdpActions.module.css";
import { Link } from "~/i18n/routing";

interface Props {
	productId: ProductDetails["uri"];
}

export const DownloadRecipeLink = ({ productId }: Props) => {
	return (
		<Link
			href={`/api/assets/pdf/${productId}`}
			target="_blank"
			type="button"
			className={clsx("transparent small", pdpStyles.downloadFreeRecipe)}
		>
			<DownloadIcon />
			<span className={pdpStyles.label}>Last ned gratisoppskrift</span>
		</Link>
	);
};
